import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (max-width: 900px) {
    /* flex-direction: column; */
  }
`;


